import React from 'react';
import { useRecoilState } from 'recoil';
import './index.scss';
import { onHoldModalDisplayState } from '../../recoil-state/request-funding-states';
import BankInfoModal from './BankInfoForModal';
import {
  isPlaidConnectedState,
  openOppHasBankStatementsState,
} from '../../recoil-state/general-states';
import { showSubmittedModalState } from '../../recoil-state/application-stage-states';
import SignNewContract from '../Application/SignAgreements/newContract';

const OnHoldModal = ({
  statusReason,
  need_updated_contract,
}: {
  statusReason: string | undefined;
  need_updated_contract: boolean | undefined;
}) => {
  const [openOppHasBankStatements] = useRecoilState(
    openOppHasBankStatementsState,
  );
  const [modalDisplay, setModalDisplay] = useRecoilState(
    onHoldModalDisplayState,
  );
  const [isConnected] = useRecoilState(isPlaidConnectedState);
  const [showSubmittedModal] = useRecoilState(
    showSubmittedModalState,
  );

  if (!need_updated_contract && !statusReason) return null;

  const closeModal = async () => {
    await setModalDisplay('modal display-none');
  };

  const getMessage = () => {
    if (need_updated_contract) {
      return (
        <>
          <SignNewContract />
        </>
      );
    }

    switch (statusReason) {
      case 'Delinquent':
      case 'Temp Pause':
        return (
          <>
            <p className="on-hold-message-text">
              Please contact our support team about your account's
              status.
              <br />
              Call 1-833-271-4499 or email support@payrofinance.com.
            </p>
            <div className="support-button-wrapper">
              <button
                id="my_custom_link"
                className="chat-with-supprt-button"
              >
                Chat with Support
              </button>
            </div>
            <p className="end-text-on-hold">
              Thank you for trusting Payro. We apologize for the
              inconvenience.
            </p>
          </>
        );
      case 'Review':
        if (openOppHasBankStatements || showSubmittedModal) {
          return (
            <p className="on-hold-message-text">
              Our team will now review the documents, and you'll be
              notified of the next steps. <br />
              If you have any questions, feel free to call
              1-833-271-4499 or email support@payrofinance.com.
            </p>
          );
        } else {
          return (
            <>
              <p>
                {isConnected === 'yes'
                  ? 'Your bank has been connected. We will review your account and get back to you.'
                  : 'We need updated bank information to fund your payroll.'}
              </p>
              <BankInfoModal />
            </>
          );
        }
    }

    return null;
  };

  const getHeader = () => {
    if (need_updated_contract)
      return 'Please sign the updated agreement';
    if (isConnected === 'yes' && statusReason === 'Review')
      return 'Bank Info Updated';
    if (openOppHasBankStatements || showSubmittedModal)
      return 'Bank Statements Uploaded Successfully';
    if (statusReason === 'Review') return 'Updated Bank Info Needed';
    return 'Funding for your business is currently unavailable';
  };

  return (
    <div className={modalDisplay}>
      <div
        className={`modal-content ${
          need_updated_contract ? 'need-new-contract' : 'review'
        }`}
      >
        <span onClick={closeModal} className="close">
          &times;
        </span>
        <p className="modal-header-on-hold">{getHeader()}</p>
        {getMessage()}
      </div>
    </div>
  );
};

export default OnHoldModal;
